import { GrantsType, hasScopedPermission } from '../../Shared/utils/auth';

export const viewSystemPolicies = (grants: GrantsType) =>
  hasScopedPermission(grants, 'system', 'policies.read');
